<template>
  <router-view />
</template>

<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";

export default {
  name: "App",
  created() {
    const currentPath = this.$router.history.current.path;
    if (currentPath === "/" || currentPath === "/app" || currentPath.includes("#")) {
      this.$router.push("/app/main/dashboard");
    }
  },
  computed: {
    ...mapGetters("alert", ["alert"])
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    },
    alert: {
      deep: true,
      handler(newAlert) {
        if (!isEmpty(newAlert.message)) {
          this.$toasted.show(newAlert.message, {
            title: newAlert.title,
            duration: 3000,
            type: newAlert.type,
            onComplete: () => this.$store.dispatch("alert/clear")
          });
        }
      }
    }
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />
